<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE CE QUE DISENTS NOS CLIENTS-->
        <div style="background: #fff;">
          <div class="justify-content-center column pt-5 mt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.testimonial_title') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
          </div>

          <div class="pt-4 pb-5 mb-5 margin">
            <splide :options="options" v-if="listTestimo.length>0">
              <splide-slide class="justify-content-center row" v-for="e in listTestimo" :key="e">


                <figure class="snip1192">
                    <blockquote>
                        <span class="font-weight-bold">{{ e.utilisateur }}</span> : {{ e.contenu }} <br> 
                        <span><i v-for="e in listTestimo[0].notation" :key="e" class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;font-size: 15px">&#xe838;</i></span>
                      </blockquote>
                    <div class="author">
                      <img src="https://desklib.com/static/src/assets/images/v2/profile_1.svg" alt="sq-sample1"/>
                    </div>
                  </figure>
              </splide-slide>
            </splide>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <div>

        <!--PARTIE CE QUE DISENTS NOS CLIENTS-->
        <div style="background: #fff" class="pt-5">
          <div class="justify-content-center column">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">
                {{ $t('home_page.testimonial_title') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
          </div>

          <div class="pt-4">
            <splide :options="options_mobile" v-if="listTestimo.length>0">
              <splide-slide class="ml-3 justify-content-center row" v-for="e in listTestimo" :key="e">
                 <figure class="snip1192">
                    <blockquote>
                        <span class="font-weight-bold">{{ e.utilisateur }}</span> : {{ e.contenu }} <br> 
                        <span><i v-for="e in listTestimo[0].notation" :key="e" class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;font-size: 15px">&#xe838;</i></span></blockquote>
                    <div class="author">
                      <img   src="https://desklib.com/static/src/assets/images/v2/profile_1.svg" alt="sq-sample1"/>
                    </div>
                  </figure>
              </splide-slide>
            </splide>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import Api from '../../services/Api';

export default {
  name: 'Home',
  components: {
    simplebar

  },
  data: () => ({
    options: {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoplay: false,
      pauseOnHover: true,
      arrows: true,
      pagination: false
    },
    options_mobile: {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      autoplay: true,
      pauseOnHover: true,
      arrows: false,
      pagination: true
    },
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    listTestimo: [],
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    GetTestimonial() {
      Api().get('testimonial/display')
          .then(res => {
            this.listTestimo = res.data.testimonial
          })
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  this.GetTestimonial();
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.newsletter_titre_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  margin-top: 6%;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}



h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}




.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}


figure.snip1192 {
  font-family: 'Raleway', Arial, sans-serif;
  position: relative;
  float: left;
  overflow: hidden;
  margin: 10px 1%;
  min-width: 220px;
  max-width: 310px;
  width: 100%;
  color: #333;
  text-align: left;
  box-shadow: none !important;
}
figure.snip1192 * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
figure.snip1192 img {
  max-width: 100%;
  height: 65px;
  width: 65px;
  border-radius: 50%;
  margin-bottom: 15px;
  display: inline-block;
  z-index: 1;
  position: relative;
  margin-top: 20px;
}
figure.snip1192 blockquote {
  margin: 0;
  display: block;
  border-radius: 10px;
  position: relative;
  background-color: #fafafa;
  padding: 30px 50px 65px 50px;
  font-size: 0.9em;
  font-weight: 500;
  margin: 0 0 -50px;
  line-height: 1.6em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  //box-shadow: 9px 12px 18px rgb(0 0 0 / 5%);
  height: 220px;
}
figure.snip1192 blockquote:before,
figure.snip1192 blockquote:after {
  font-family: 'FontAwesome';
  content: "\201C";
  position: absolute;
  font-size: 50px;
  opacity: 0.3;
  font-style: normal;
}
figure.snip1192 blockquote:before {
  top: 35px;
  left: 20px;
}
figure.snip1192 blockquote:after {
  content: "\201D";
  right: 20px;
  bottom: 35px;
}
figure.snip1192 .author {
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
}
figure.snip1192 .author h5 {
  opacity: 0.8;
  margin: 0;
  font-weight: 800;
}
figure.snip1192 .author h5 span {
  font-weight: 400;
  text-transform: none;
  display: block;
}
/* Demo purposes only */
// body {
//   background-color: #212121;
// }

</style>

